/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalDocumentDto } from '../transmittalDocumentDto.schema';

export const transmittalRecordInputDtoStatusIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const TransmittalRecordInputDto = zod.object({
  "statusId": zod.union([zod.number(),zod.string().regex(transmittalRecordInputDtoStatusIdRegExpTwo)]).optional(),
  "date": zod.coerce.date().nullish(),
  "receiverId": zod.string().uuid().nullish(),
  "receiverName": zod.string().nullish(),
  "transmittalDocuments": zod.array(zod.lazy(() => TransmittalDocumentDto)).optional()
});

export type TransmittalRecordInputDto = zod.input<typeof TransmittalRecordInputDto>;
export type TransmittalRecordInputDtoOutput = zod.output<typeof TransmittalRecordInputDto>;
